import './$layout.css.proxy.js';
/* src/routes/$layout.svelte generated by Svelte v3.55.0 */
import {
	SvelteComponentDev,
	add_location,
	append_hydration_dev,
	attr_dev,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	create_slot,
	destroy_component,
	detach_dev,
	dispatch_dev,
	element,
	get_all_dirty_from_scope,
	get_slot_changes,
	globals,
	init,
	insert_hydration_dev,
	listen_dev,
	mount_component,
	prop_dev,
	run_all,
	safe_not_equal,
	select_option,
	set_data_dev,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_slot_base,
	validate_slots
} from "../../web_modules/svelte/internal.js";

const { console: console_1 } = globals;
import Nav from '../components/Nav.js';
import { onMount, setContext } from '../../web_modules/svelte.js';
import { writable } from '../../web_modules/svelte/store.js';
import Icon from '../components/Icon.js';
const file = "src/routes/$layout.svelte";

// (169:6) {#if showSettings}
function create_if_block(ctx) {
	let div9;
	let div6;
	let div3;
	let div2;
	let label0;
	let t0;
	let t1;
	let div1;
	let div0;
	let select;
	let option0;
	let t2;
	let option1;
	let t3;
	let option2;
	let t4;
	let t5;
	let div5;
	let div4;
	let label1;
	let span0;
	let t6;
	let t7;
	let input;
	let input_disabled_value;
	let input_checked_value;
	let t8;
	let span4;
	let span1;
	let t9;
	let span2;
	let t10_value = (/*sdkInit*/ ctx[4] ? 'Opted In' : 'Waiting for init...') + "";
	let t10;
	let t11;
	let span3;
	let t12_value = (/*sdkInit*/ ctx[4] ? 'Opted Out' : 'Waiting for init...') + "";
	let t12;
	let t13;
	let div8;
	let label2;
	let abbr;
	let t14;
	let t15;
	let t16;
	let div7;
	let textarea;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			div9 = element("div");
			div6 = element("div");
			div3 = element("div");
			div2 = element("div");
			label0 = element("label");
			t0 = text("Initial Consent");
			t1 = space();
			div1 = element("div");
			div0 = element("div");
			select = element("select");
			option0 = element("option");
			t2 = text("None");
			option1 = element("option");
			t3 = text("Opt In");
			option2 = element("option");
			t4 = text("Opt Out");
			t5 = space();
			div5 = element("div");
			div4 = element("div");
			label1 = element("label");
			span0 = element("span");
			t6 = text("Consent");
			t7 = space();
			input = element("input");
			t8 = space();
			span4 = element("span");
			span1 = element("span");
			t9 = space();
			span2 = element("span");
			t10 = text(t10_value);
			t11 = space();
			span3 = element("span");
			t12 = text(t12_value);
			t13 = space();
			div8 = element("div");
			label2 = element("label");
			abbr = element("abbr");
			t14 = text("*");
			t15 = text("\n            Change CDN Script");
			t16 = space();
			div7 = element("div");
			textarea = element("textarea");
			this.h();
		},
		l: function claim(nodes) {
			div9 = claim_element(nodes, "DIV", { class: true, role: true });
			var div9_nodes = children(div9);
			div6 = claim_element(div9_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			div3 = claim_element(div6_nodes, "DIV", { class: true, role: true });
			var div3_nodes = children(div3);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			label0 = claim_element(div2_nodes, "LABEL", { class: true, for: true });
			var label0_nodes = children(label0);
			t0 = claim_text(label0_nodes, "Initial Consent");
			label0_nodes.forEach(detach_dev);
			t1 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			select = claim_element(div0_nodes, "SELECT", { class: true, id: true });
			var select_nodes = children(select);
			option0 = claim_element(select_nodes, "OPTION", {});
			var option0_nodes = children(option0);
			t2 = claim_text(option0_nodes, "None");
			option0_nodes.forEach(detach_dev);
			option1 = claim_element(select_nodes, "OPTION", {});
			var option1_nodes = children(option1);
			t3 = claim_text(option1_nodes, "Opt In");
			option1_nodes.forEach(detach_dev);
			option2 = claim_element(select_nodes, "OPTION", {});
			var option2_nodes = children(option2);
			t4 = claim_text(option2_nodes, "Opt Out");
			option2_nodes.forEach(detach_dev);
			select_nodes.forEach(detach_dev);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			div2_nodes.forEach(detach_dev);
			div3_nodes.forEach(detach_dev);
			t5 = claim_space(div6_nodes);
			div5 = claim_element(div6_nodes, "DIV", { class: true, role: true });
			var div5_nodes = children(div5);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			label1 = claim_element(div4_nodes, "LABEL", { class: true });
			var label1_nodes = children(label1);
			span0 = claim_element(label1_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t6 = claim_text(span0_nodes, "Consent");
			span0_nodes.forEach(detach_dev);
			t7 = claim_space(label1_nodes);

			input = claim_element(label1_nodes, "INPUT", {
				type: true,
				name: true,
				"aria-describedby": true
			});

			t8 = claim_space(label1_nodes);
			span4 = claim_element(label1_nodes, "SPAN", { id: true, class: true, "aria-live": true });
			var span4_nodes = children(span4);
			span1 = claim_element(span4_nodes, "SPAN", { class: true });
			children(span1).forEach(detach_dev);
			t9 = claim_space(span4_nodes);
			span2 = claim_element(span4_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);
			t10 = claim_text(span2_nodes, t10_value);
			span2_nodes.forEach(detach_dev);
			t11 = claim_space(span4_nodes);
			span3 = claim_element(span4_nodes, "SPAN", { class: true });
			var span3_nodes = children(span3);
			t12 = claim_text(span3_nodes, t12_value);
			span3_nodes.forEach(detach_dev);
			span4_nodes.forEach(detach_dev);
			label1_nodes.forEach(detach_dev);
			div4_nodes.forEach(detach_dev);
			div5_nodes.forEach(detach_dev);
			div6_nodes.forEach(detach_dev);
			t13 = claim_space(div9_nodes);
			div8 = claim_element(div9_nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			label2 = claim_element(div8_nodes, "LABEL", { class: true, for: true });
			var label2_nodes = children(label2);
			abbr = claim_element(label2_nodes, "ABBR", { class: true, title: true });
			var abbr_nodes = children(abbr);
			t14 = claim_text(abbr_nodes, "*");
			abbr_nodes.forEach(detach_dev);
			t15 = claim_text(label2_nodes, "\n            Change CDN Script");
			label2_nodes.forEach(detach_dev);
			t16 = claim_space(div8_nodes);
			div7 = claim_element(div8_nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			textarea = claim_element(div7_nodes, "TEXTAREA", { id: true, placeholder: true, class: true });
			children(textarea).forEach(detach_dev);
			div7_nodes.forEach(detach_dev);
			div8_nodes.forEach(detach_dev);
			div9_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(label0, "class", "slds-form-element__label");
			attr_dev(label0, "for", "select-01");
			add_location(label0, file, 173, 14, 6724);
			option0.__value = "none";
			option0.value = option0.__value;
			add_location(option0, file, 179, 20, 7098);
			option1.__value = "opt-in";
			option1.value = option1.__value;
			add_location(option1, file, 180, 20, 7153);
			option2.__value = "opt-out";
			option2.value = option2.__value;
			add_location(option2, file, 181, 20, 7212);
			attr_dev(select, "class", "slds-select");
			attr_dev(select, "id", "select-01");
			add_location(select, file, 178, 18, 6961);
			attr_dev(div0, "class", "slds-select_container");
			add_location(div0, file, 177, 16, 6907);
			attr_dev(div1, "class", "slds-form-element__control");
			add_location(div1, file, 176, 14, 6850);
			attr_dev(div2, "class", "slds-form-element slds-form-element_horizontal");
			add_location(div2, file, 172, 12, 6649);
			attr_dev(div3, "class", "slds-form__item");
			attr_dev(div3, "role", "listitem");
			add_location(div3, file, 171, 10, 6591);
			attr_dev(span0, "class", "slds-form-element__label slds-m-bottom_none");
			add_location(span0, file, 191, 16, 7568);
			attr_dev(input, "type", "checkbox");
			attr_dev(input, "name", "checkbox-toggle-3");
			input.value = "checkbox-toggle-3";
			attr_dev(input, "aria-describedby", "checkbox-toggle-3");
			input.disabled = input_disabled_value = /*sdkInit*/ ctx[4] ? '' : 'disabled';
			input.checked = input_checked_value = /*isConsented*/ ctx[5] ? 'checked' : '';
			add_location(input, file, 192, 16, 7657);
			attr_dev(span1, "class", "slds-checkbox_faux");
			add_location(span1, file, 201, 18, 8153);
			attr_dev(span2, "class", "slds-checkbox_on");
			add_location(span2, file, 202, 18, 8212);
			attr_dev(span3, "class", "slds-checkbox_off");
			add_location(span3, file, 203, 18, 8315);
			attr_dev(span4, "id", "checkbox-toggle-3");
			attr_dev(span4, "class", "slds-checkbox_faux_container");
			attr_dev(span4, "aria-live", "assertive");
			add_location(span4, file, 200, 16, 8046);
			attr_dev(label1, "class", "slds-checkbox_toggle slds-grid");
			add_location(label1, file, 190, 14, 7505);
			attr_dev(div4, "class", "slds-form-element slds-form-element_horizontal");
			add_location(div4, file, 189, 12, 7430);
			attr_dev(div5, "class", "slds-form__item");
			attr_dev(div5, "role", "listitem");
			add_location(div5, file, 188, 10, 7372);
			attr_dev(div6, "class", "slds-form__row");
			add_location(div6, file, 170, 8, 6552);
			attr_dev(abbr, "class", "slds-required");
			attr_dev(abbr, "title", "required");
			add_location(abbr, file, 212, 12, 8621);
			attr_dev(label2, "class", "slds-form-element__label");
			attr_dev(label2, "for", "cdn-script");
			add_location(label2, file, 211, 10, 8551);
			attr_dev(textarea, "id", "cdn-script");
			attr_dev(textarea, "placeholder", "No CDN Script Configured");
			attr_dev(textarea, "class", "slds-input svelte-1pa2c2t");
			textarea.value = /*activeCdnScript*/ ctx[1];
			add_location(textarea, file, 216, 12, 8788);
			attr_dev(div7, "class", "slds-form-element__control");
			add_location(div7, file, 215, 10, 8735);
			attr_dev(div8, "class", "slds-form-element");
			add_location(div8, file, 210, 8, 8509);
			attr_dev(div9, "class", "slds-form svelte-1pa2c2t");
			attr_dev(div9, "role", "list");
			add_location(div9, file, 169, 8, 6508);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div9, anchor);
			append_hydration_dev(div9, div6);
			append_hydration_dev(div6, div3);
			append_hydration_dev(div3, div2);
			append_hydration_dev(div2, label0);
			append_hydration_dev(label0, t0);
			append_hydration_dev(div2, t1);
			append_hydration_dev(div2, div1);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, select);
			append_hydration_dev(select, option0);
			append_hydration_dev(option0, t2);
			append_hydration_dev(select, option1);
			append_hydration_dev(option1, t3);
			append_hydration_dev(select, option2);
			append_hydration_dev(option2, t4);
			select_option(select, /*initialConsentSelection*/ ctx[3]);
			append_hydration_dev(div6, t5);
			append_hydration_dev(div6, div5);
			append_hydration_dev(div5, div4);
			append_hydration_dev(div4, label1);
			append_hydration_dev(label1, span0);
			append_hydration_dev(span0, t6);
			append_hydration_dev(label1, t7);
			append_hydration_dev(label1, input);
			append_hydration_dev(label1, t8);
			append_hydration_dev(label1, span4);
			append_hydration_dev(span4, span1);
			append_hydration_dev(span4, t9);
			append_hydration_dev(span4, span2);
			append_hydration_dev(span2, t10);
			append_hydration_dev(span4, t11);
			append_hydration_dev(span4, span3);
			append_hydration_dev(span3, t12);
			append_hydration_dev(div9, t13);
			append_hydration_dev(div9, div8);
			append_hydration_dev(div8, label2);
			append_hydration_dev(label2, abbr);
			append_hydration_dev(abbr, t14);
			append_hydration_dev(label2, t15);
			append_hydration_dev(div8, t16);
			append_hydration_dev(div8, div7);
			append_hydration_dev(div7, textarea);

			if (!mounted) {
				dispose = [
					listen_dev(select, "change", handleInitialConsentChange, false, false, false),
					listen_dev(input, "change", /*toggleConsent*/ ctx[8], false, false, false),
					listen_dev(textarea, "change", /*handleCdnScriptChange*/ ctx[6], false, false, false),
					listen_dev(textarea, "keypress", /*handleCdnScriptKeypress*/ ctx[7], false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*initialConsentSelection*/ 8) {
				select_option(select, /*initialConsentSelection*/ ctx[3]);
			}

			if (dirty & /*sdkInit*/ 16 && input_disabled_value !== (input_disabled_value = /*sdkInit*/ ctx[4] ? '' : 'disabled')) {
				prop_dev(input, "disabled", input_disabled_value);
			}

			if (dirty & /*isConsented*/ 32 && input_checked_value !== (input_checked_value = /*isConsented*/ ctx[5] ? 'checked' : '')) {
				prop_dev(input, "checked", input_checked_value);
			}

			if (dirty & /*sdkInit*/ 16 && t10_value !== (t10_value = (/*sdkInit*/ ctx[4] ? 'Opted In' : 'Waiting for init...') + "")) set_data_dev(t10, t10_value);
			if (dirty & /*sdkInit*/ 16 && t12_value !== (t12_value = (/*sdkInit*/ ctx[4] ? 'Opted Out' : 'Waiting for init...') + "")) set_data_dev(t12, t12_value);

			if (dirty & /*activeCdnScript*/ 2) {
				prop_dev(textarea, "value", /*activeCdnScript*/ ctx[1]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div9);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(169:6) {#if showSettings}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let nav;
	let t0;
	let div1;
	let main;
	let t1;
	let div0;
	let span;
	let icon;
	let t2;
	let current;
	let mounted;
	let dispose;

	nav = new Nav({
			props: { segment: /*segment*/ ctx[0] },
			$$inline: true
		});

	const default_slot_template = /*#slots*/ ctx[11].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[10], null);

	icon = new Icon({
			props: { type: "standard", name: "settings" },
			$$inline: true
		});

	let if_block = /*showSettings*/ ctx[2] && create_if_block(ctx);

	const block = {
		c: function create() {
			create_component(nav.$$.fragment);
			t0 = space();
			div1 = element("div");
			main = element("main");
			if (default_slot) default_slot.c();
			t1 = space();
			div0 = element("div");
			span = element("span");
			create_component(icon.$$.fragment);
			t2 = space();
			if (if_block) if_block.c();
			this.h();
		},
		l: function claim(nodes) {
			claim_component(nav.$$.fragment, nodes);
			t0 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			main = claim_element(div1_nodes, "MAIN", { class: true });
			var main_nodes = children(main);
			if (default_slot) default_slot.l(main_nodes);
			main_nodes.forEach(detach_dev);
			t1 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { id: true, class: true });
			var div0_nodes = children(div0);
			span = claim_element(div0_nodes, "SPAN", { "data-settings": true, class: true });
			var span_nodes = children(span);
			claim_component(icon.$$.fragment, span_nodes);
			span_nodes.forEach(detach_dev);
			t2 = claim_space(div0_nodes);
			if (if_block) if_block.l(div0_nodes);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(main, "class", "svelte-1pa2c2t");
			add_location(main, file, 159, 4, 6197);
			attr_dev(span, "data-settings", "");
			attr_dev(span, "class", "slds-icon_container slds-icon-standard-settings svelte-1pa2c2t");
			add_location(span, file, 164, 6, 6308);
			attr_dev(div0, "id", "sdk-switcher");
			attr_dev(div0, "class", "svelte-1pa2c2t");
			toggle_class(div0, "show-settings", /*showSettings*/ ctx[2]);
			add_location(div0, file, 163, 4, 6243);
			attr_dev(div1, "class", "wrapper svelte-1pa2c2t");
			add_location(div1, file, 158, 0, 6171);
		},
		m: function mount(target, anchor) {
			mount_component(nav, target, anchor);
			insert_hydration_dev(target, t0, anchor);
			insert_hydration_dev(target, div1, anchor);
			append_hydration_dev(div1, main);

			if (default_slot) {
				default_slot.m(main, null);
			}

			append_hydration_dev(div1, t1);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, span);
			mount_component(icon, span, null);
			append_hydration_dev(div0, t2);
			if (if_block) if_block.m(div0, null);
			current = true;

			if (!mounted) {
				dispose = listen_dev(span, "click", /*toggleSettings*/ ctx[9], false, false, false);
				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			const nav_changes = {};
			if (dirty & /*segment*/ 1) nav_changes.segment = /*segment*/ ctx[0];
			nav.$set(nav_changes);

			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[10],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[10], dirty, null),
						null
					);
				}
			}

			if (/*showSettings*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (!current || dirty & /*showSettings*/ 4) {
				toggle_class(div0, "show-settings", /*showSettings*/ ctx[2]);
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(default_slot, local);
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(default_slot, local);
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(nav, detaching);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(div1);
			if (default_slot) default_slot.d(detaching);
			destroy_component(icon);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function clearSdkCookies() {
	const MAX_LOOPS = 10; // so we don't get into an infinite loop
	let i = 0;

	while ((/(_sfid_.*)=/).test(document.cookie) && i < MAX_LOOPS) {
		document.cookie = `${RegExp.$1}=; Domain=${window.location.hostname}; Path=/; expires=1 Jan 1970 00:00:00 GMT;`;
		document.cookie = `${RegExp.$1}=; Domain=.${window.location.hostname}; Path=/; expires=1 Jan 1970 00:00:00 GMT;`;
		i += 1;
	}
}

function handleInitialConsentChange(evt) {
	const consentOptionValue = evt.currentTarget.value.trim();
	console.log(`initial consent changed to ${consentOptionValue} (requires refresh)`);
	localStorage.setItem('initial_consent_selection', consentOptionValue);
	clearSdkCookies();
	location.reload();
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('$layout', slots, ['default']);

	const OPT_IN = {
		status: 'Opt In',
		provider: 'CDP_TEST_SITE',
		purpose: 'Tracking'
	};

	const OPT_OUT = {
		status: 'Opt Out',
		provider: 'CDP_TEST_SITE',
		purpose: 'Tracking'
	};

	let { segment } = $$props;

	// variables controlling the UI state
	let activeCdnScript = '';

	let showSettings = false;
	let initialConsentSelection = 'none';
	let sdkLoaded = false;
	let sdkInit = false;
	let isConsented = false;

	// manage the baseUrl using an observable store exposed to
	// all child components via getContext('baseUrl') so that
	// the value is reactive
	let baseUrl = writable('');

	setContext('baseUrl', baseUrl);

	// load any persisted configuration from localStorage in the onMount callback
	// and configure the UI to reflect the persisted settings
	onMount(() => {
		console.group('Initializing test site');

		// this might not be needed anymore but was useful for when the site is deployed to a
		// non-root path (e.g.; site root is /my-test-site instead of /)
		const newBaseUrl = window.__SVELTE__ && window.__SVELTE__.baseUrl;

		if (window.__SVELTE__ && window.__SVELTE__.baseUrl) {
			baseUrl.set(newBaseUrl);
		}

		console.log(`baseUrl: ${newBaseUrl || '/'}`);

		// load the settings dialog visibility state or set a sensible default
		const showSettingsValue = localStorage.getItem('show_settings');

		if (['true', 'false'].includes(showSettingsValue)) {
			$$invalidate(2, showSettings = showSettingsValue === 'true');
		} else {
			$$invalidate(2, showSettings = true);
		}

		console.log(`show settings: ${showSettings}`);

		// restore whatever initial consent was previously chosen
		$$invalidate(3, initialConsentSelection = localStorage.getItem('initial_consent_selection'));

		if (initialConsentSelection == null) {
			$$invalidate(3, initialConsentSelection = 'none');
		}

		updateInitialConsents(initialConsentSelection);
		console.log(`initial consent selection: ${initialConsentSelection}, window.CONSENTS = `, window.CONSENTS);

		// use the populated script to fetch the SDK dynamically and load it into the page
		$$invalidate(1, activeCdnScript = localStorage.getItem('cdn_script'));

		if (activeCdnScript) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = activeCdnScript;
			script.onload = () => onSdkLoaded();
			document.body.appendChild(script);
			console.log(`CDN script: ${activeCdnScript}`);
			console.groupEnd();
		} else {
			console.log(`CDN script: MISSING!`);
			console.groupEnd();
			console.error('No CDN script configured!');
		}
	});

	// the consent toggle only makes sense to configure once the SDK is loaded since
	// it depends on the SDK's state and toggles it via the SDK's API
	function onSdkLoaded() {
		console.log(`CDN script loaded`);
		sdkLoaded = true;

		document.addEventListener(
			window.SalesforceInteractions.CustomEvents.OnInit,
			() => {
				setTimeout(
					() => {
						$$invalidate(4, sdkInit = true);
						const consents = window.SalesforceInteractions.getConsents();
						console.log(`getConsents: `, consents);

						$$invalidate(5, isConsented = consents.some(consentWithMetadata => {
							return consentWithMetadata.consent.status === window.SalesforceInteractions.ConsentStatus.OptIn;
						}));

						console.log(`has consent: `, isConsented);
					},
					1
				);
			},
			{ once: true }
		);
	}

	function updateInitialConsents(state) {
		if (state === 'opt-in') {
			window.CONSENTS = [OPT_IN];
		} else if (state === 'opt-out') {
			window.CONSENTS = [OPT_OUT];
		} else {
			window.CONSENTS = [];
		}
	}

	function handleCdnScriptChange(evt) {
		const newValue = evt.currentTarget.value.trim();
		console.log(`sdk script changed to ${newValue} (requires refresh)`);

		if (activeCdnScript !== newValue) {
			localStorage.setItem('cdn_script', newValue);
			location.reload();
		}
	}

	function handleCdnScriptKeypress(evt) {
		if (evt.charCode === 13) {
			handleCdnScriptChange(evt);
		}
	}

	function toggleConsent() {
		const currentlyConsented = window.SalesforceInteractions.getConsents().some(consentWithMetadata => {
			return consentWithMetadata.consent.status === window.SalesforceInteractions.ConsentStatus.OptIn;
		});

		console.log(`toggling consent from ${currentlyConsented ? '"Opt In"' : '"Opt Out"'} → ${!currentlyConsented ? '"Opt In"' : '"Opt Out"'}`);
		window.SalesforceInteractions.updateConsents([currentlyConsented ? OPT_OUT : OPT_IN]);
		$$invalidate(5, isConsented = !currentlyConsented);
		console.log(`get consents: `, window.SalesforceInteractions.getConsents());
	}

	function toggleSettings() {
		console.log(`toggling settings visibility ${showSettings} → ${!showSettings}`);
		$$invalidate(2, showSettings = !showSettings);
		$$invalidate(3, initialConsentSelection = 'none');
		localStorage.setItem('initial_consent_selection', initialConsentSelection);
		localStorage.setItem('show_settings', `${showSettings}`);
	}

	$$self.$$.on_mount.push(function () {
		if (segment === undefined && !('segment' in $$props || $$self.$$.bound[$$self.$$.props['segment']])) {
			console_1.warn("<$layout> was created without expected prop 'segment'");
		}
	});

	const writable_props = ['segment'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console_1.warn(`<$layout> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('segment' in $$props) $$invalidate(0, segment = $$props.segment);
		if ('$$scope' in $$props) $$invalidate(10, $$scope = $$props.$$scope);
	};

	$$self.$capture_state = () => ({
		Nav,
		onMount,
		setContext,
		writable,
		Icon,
		OPT_IN,
		OPT_OUT,
		segment,
		activeCdnScript,
		showSettings,
		initialConsentSelection,
		sdkLoaded,
		sdkInit,
		isConsented,
		baseUrl,
		onSdkLoaded,
		updateInitialConsents,
		clearSdkCookies,
		handleCdnScriptChange,
		handleCdnScriptKeypress,
		handleInitialConsentChange,
		toggleConsent,
		toggleSettings
	});

	$$self.$inject_state = $$props => {
		if ('segment' in $$props) $$invalidate(0, segment = $$props.segment);
		if ('activeCdnScript' in $$props) $$invalidate(1, activeCdnScript = $$props.activeCdnScript);
		if ('showSettings' in $$props) $$invalidate(2, showSettings = $$props.showSettings);
		if ('initialConsentSelection' in $$props) $$invalidate(3, initialConsentSelection = $$props.initialConsentSelection);
		if ('sdkLoaded' in $$props) sdkLoaded = $$props.sdkLoaded;
		if ('sdkInit' in $$props) $$invalidate(4, sdkInit = $$props.sdkInit);
		if ('isConsented' in $$props) $$invalidate(5, isConsented = $$props.isConsented);
		if ('baseUrl' in $$props) baseUrl = $$props.baseUrl;
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [
		segment,
		activeCdnScript,
		showSettings,
		initialConsentSelection,
		sdkInit,
		isConsented,
		handleCdnScriptChange,
		handleCdnScriptKeypress,
		toggleConsent,
		toggleSettings,
		$$scope,
		slots
	];
}

class $layout extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { segment: 0 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "$layout",
			options,
			id: create_fragment.name
		});
	}

	get segment() {
		throw new Error("<$layout>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set segment(value) {
		throw new Error("<$layout>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default $layout;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
//# sourceMappingURL=$layout.js.map
